import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const CoverLink = styled.div`
  border-radius: 4px;

  cursor: pointer;

  img {
    border-radius: 4px;
  }
`;

export const Cover = styled.div`
  overflow: hidden;
  aspect-ratio: 3 / 2;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  line-height: 130%;
`;

export const ContentLink = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 8px;

  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  font-family: ${fontRobotoCondensed};
`;
